/**
 * Pure ELO helpers extracted from playerUtils — no React, no Supabase.
 * Used by singlesCourtEngine, normalizedScoring, etc.
 */

/** @param {object|null|undefined} player */
export const getSinglesClubEloRating = (player) => {
  if (!player) return null;
  const raw = player.singles_elo_rating;
  if (raw == null || raw === '') return null;
  const s = Number(raw);
  if (!Number.isFinite(s)) return null;
  return Math.round(s);
};

/** Matchmaking / simulation only: numeric fallback when club singles Elo is unset. */
export const getSinglesEloForComputation = (player, fallback = 1200) =>
  getSinglesClubEloRating(player) ?? fallback;
